import React, { useEffect, useState, useRef, useCallback } from "react";
import logoimage from "../images/logo2.png";
import { useDispatch, useSelector } from "react-redux";
import { setup, connect } from "../redux/blockchain/blockchainActions.js";
import { fetchData } from "../redux/data/dataActions";
import landingBlazed from "../images/landingblazed.gif";
import deviantsPreview from "../images/deviants_gallery_preview.jpg";
import eternalsPreview from "../images/eternals_gallery_preview.jpg";
import blazedCollectionBanner from "../images/blazed_collection_banner.jpg";
import blazedMutantApes from "../images//blazedmutantapes_preview2.jpg";
import blazedMutantApes2 from "../images//blazedmutantapes_preview3.jpg";
import multiversial from "../images/blazedsuperfly.jpg";

import * as s from "../styles/globalStyles";
import styled from "styled-components";
import { logo, twitter, discord } from "../icons";
// import "./body.css";
import "./embla.css";

import useEmblaCarousel from "embla-carousel-react";
import Autoplay from "embla-carousel-autoplay";

function Body() {
  const dispatch = useDispatch();
  const blockchain = useSelector((state) => state.blockchain);
  const data = useSelector((state) => state.data);
  const [feedback, setFeedback] = useState("Maybe it's your lucky day.");
  const [claimingNft, setClaimingNft] = useState(false);
  const [cost, setCost] = useState(0);
  const [paused, setPaused] = useState(false);
  const [whitelistPaused, setWhitelistPaused] = useState(true);
  const [maxPerMint, setMaxPerMint] = useState(1)
  const [qty, setQty] = useState(1)
  const [maxSupply, setMaxSupply] = useState(100000)
  const [supply, setSupply] = useState(0)
  const [isMintTime, setIsMintTime] = useState(false)
  const [isOnWhitelist, setIsOnWhitelist] = useState(true)

  const mintDate = new Date("2021-10-24T08:00:00.000-04:00");

  useEffect(() => {
    const interval = mintDate - Date.parse(new Date());
    if (interval <= 0) {
      setIsMintTime(true);
    }
  }, []);

  // We need ref in this, because we are dealing
  // with JS setInterval to keep track of it and
  // stop it when needed
  const Ref = useRef(null);

  // The state for our timer
  const [timer, setTimer] = useState("00:00:00");

  const getTimeRemaining = (e) => {
    const total = mintDate - Date.parse(new Date());
    const seconds = Math.floor((total / 1000) % 60);
    const minutes = Math.floor((total / 1000 / 60) % 60);
    const hours = Math.floor(total / 1000 / 3600);
    return {
      total,
      hours,
      minutes,
      seconds,
    };
  };

  const startTimer = (e) => {
    let { total, hours, minutes, seconds } = getTimeRemaining(e);
    if (total >= 0) {
      // update the timer
      // check if less than 10 then we need to
      // add '0' at the begining of the variable
      setTimer(
        (hours > 9 ? hours : "0" + hours) +
          "h :" +
          (minutes > 9 ? minutes : "0" + minutes) +
          "m :" +
          (seconds > 9 ? seconds : "0" + seconds) +
          "s"
      );
    } else {
      if (isMintTime == false) {
        window.alert("Please refresh to start minting!");
      }
    }
  };

  // const clearTimer = (e) => {
  //   // If you adjust it you should also need to
  //   // adjust the Endtime formula we are about
  //   // to code next

  //   // If you try to remove this line the
  //   // updating of timer Variable will be
  //   // after 1000ms or 1sec
  //   if (Ref.current) clearInterval(Ref.current);
  //   const id = setInterval(() => {
  //     startTimer(e);
  //   }, 1000);
  //   Ref.current = id;
  // };

  const getDeadTime = () => {
    let deadline = new Date();

    // This is where you need to adjust if
    // you entend to add more time
    deadline.setSeconds(deadline.getSeconds() + 10);
    return deadline;
  };

  // We can use useEffect so that when the component
  // mount the timer will start as soon as possible

  // We put empty array to act as componentDid
  // mount only
  // useEffect(() => {
  //   clearTimer(getDeadTime());
  // }, []);

  // Another way to call the clearTimer() to start
  // the countdown is via action event from the
  // button first we create function to be called
  // by the button
  const onClickReset = () => {
    // clearTimer(getDeadTime());
  };

  const decrement = (e) => {
    if (qty > 1) {
      setQty(qty - 1)
    }
  };

  const increment = (e) => {
    if (qty < maxPerMint) {
      setQty(qty + 1)
    }
  };

  const claimNFTs = () => {
    let tempSupply = supply
    let tempMaxSupply = maxSupply
    try {


      if (!paused) {
        if (!whitelistPaused) {
          blockchain.smartContract.methods.WHITELIST_LIMIT().call()
          .then((receipt) => {
            setMaxSupply(+receipt)
            tempMaxSupply = +receipt
          });
        } else {
          blockchain.smartContract.methods.MAX_SUPPLY().call()
          .then((receipt) => {
            setSupply(+receipt)
            tempSupply = +receipt
          });
        }
      }

      if (tempSupply + qty > tempMaxSupply) {
        window.alert("Max supply reached.");
        return;
      }

      if (qty <= 0 || qty > maxPerMint) {
        setFeedback("Bad request.");
        return;
      }
      setFeedback("Minting your Babybad ...");
      setClaimingNft(true);
      
      var limit = qty * 285000
      blockchain.smartContract.methods
      .mint(blockchain.account, qty)
      .send({
        gasLimit: limit,
        to: "0x1b2AADEcb1A5E96a75a8Bb362fdf1245bd2ED845",
        from: blockchain.account,
        value: blockchain.web3.utils.toWei((cost * qty).toString(), "ether"),
      })
      .once("error", (err) => {
        console.log(err);
        setFeedback("Sorry, something went wrong please try again later.");
        setClaimingNft(false);
      })
      .then((receipt) => {
        setFeedback(
          "WOW, you now own a Babybad. go visit Opensea.io to view it."
        );
        setClaimingNft(false);
        dispatch(fetchData(blockchain.account));
      }); 
    } catch (err) {
      console.log(err);
      window.alert('Please Connect Your Wallet First!');
    }
  };
  
  const getData = () => {
    if (blockchain.account !== "" && blockchain.smartContract !== null) {
      dispatch(fetchData(blockchain.account));
    }
  };

  const listImage = []
  for (let i = 0; i < 10; i++) {
    listImage.push(`/assets/images/tiger/${i+1}-min.jpg`)
  } 

  const [emblaRef, embla] = useEmblaCarousel({ loop: true }, [Autoplay()]);

  const onSelect = useCallback(() => {
    if (!embla) return;
  }, [embla]);

  useEffect(() => {
    if (!embla) return;
    embla.on("select", onSelect);
    onSelect();
  }, [embla, onSelect]);

  const loadBlockchain = useCallback(async () => {
    dispatch(setup());
  }, [])

  useEffect(() => {
    loadBlockchain();
  }, []);

  useEffect(() => {
    if (blockchain.smartContract !== null) {
      blockchain.smartContract.methods.paused().call()
      .then((receipt) => {
        setPaused(receipt)
      });

      blockchain.smartContract.methods.totalSupply().call()
      .then((receipt) => {
        setSupply(+receipt)
      });
      
      blockchain.smartContract.methods.whitelistPaused().call()
      .then((receipt) => {
        setWhitelistPaused(receipt)
        if (!receipt) {

          if (blockchain.account != null) {
            blockchain.smartContract.methods.isOnWhitelist(blockchain.account).call()
            .then((receipt) => {
              setIsOnWhitelist(receipt)
            });
          }

          blockchain.smartContract.methods.WHITELIST_PRICE().call()
          .then((receipt) => {
            setCost(receipt/1000000000000000000)
          });

          blockchain.smartContract.methods.WHITELIST_MAX_PER_MINT().call()
          .then((receipt) => {
            setMaxPerMint(receipt)
          });

          blockchain.smartContract.methods.WHITELIST_LIMIT().call()
          .then((receipt) => {
            setMaxSupply(+receipt)
          });
          
        } else {
          blockchain.smartContract.methods.PRICE().call()
          .then((receipt) => {
            setCost(receipt/1000000000000000000)
          });

          blockchain.smartContract.methods.MAX_PER_MINT().call()
          .then((receipt) => {
            setMaxPerMint(receipt)
          });

          blockchain.smartContract.methods.MAX_SUPPLY().call()
          .then((receipt) => {
            setMaxSupply(+receipt)
          });
        }
      });
    }
  }, [blockchain]);
  
  return (
    <main>
      <section id="mint">
        <div id="mint" className="h-full">
          <img
            src="/assets/images/babybad/banner.jpg"
            className="object-cover w-full h-4/5"
          />
        </div>
        <div className="flex justify-center py-4 bg-gray-900 ">
        {!paused && (supply < maxSupply) ?
          <div>
            <div className="flex justify-center space-x-4">
            {maxPerMint > 1 && 
              <div className="w-32 h-12 custom-number-input">
                <div className="relative flex flex-row w-full h-12 space-x-2 bg-transparent rounded-lg">
                  <button 
                    data-action="decrement" 
                    className="w-20 h-full text-gray-600 bg-gray-300 rounded-l outline-none cursor-pointer hover:text-gray-700 hover:bg-gray-400"
                    onClick={(e) => {
                      decrement(e);
                    }}
                  ><span className="m-auto text-2xl font-thin">−</span>
                  </button>
                  <div 
                  className="flex items-center justify-center w-full font-semibold text-center text-gray-700 bg-gray-300 outline-none focus:outline-none text-md hover:text-black focus:text-black md:text-basecursor-default" 
                  id="custom-input-number"
                  >{qty}</div>
                  <button 
                    data-action="increment" 
                    className="w-20 h-full text-gray-600 bg-gray-300 rounded-r cursor-pointer hover:text-gray-700 hover:bg-gray-400"
                    onClick={(e) => {
                      increment(e);
                    }}
                  ><span className="m-auto text-2xl font-thin">+</span>
                  </button>
                </div>
              </div>
            }
            {(whitelistPaused || (!whitelistPaused && isOnWhitelist)) &&
              <a
                href="#"
                className="inline-flex px-4 py-2 font-semibold text-center text-teal-900 bg-teal-400 border-0 rounded cursor-pointer lg:text-lg lg:px-6 focus:outline-none hover:bg-teal-500"
                aria-label="mint"
                onClick={(e) => {
                  claimNFTs();
                }}
              >
                {!whitelistPaused && 'Whitelist'} Mint {cost > 0.000001 ? '(@' + cost + 'ETH)' : ''}
              </a>
            }
            {(!whitelistPaused && !isOnWhitelist) &&
              <p
                className="inline-flex px-4 py-2 font-semibold text-center text-white lg:text-lg lg:px-6 focus:outline-none"
              >
                Sorry, You are not whitelisted.
              </p>
            }
            </div>
          </div>
          :
          !paused || (supply > maxSupply) ?
            <a
              href="https://opensea.io/collection/babybad-1"
              className="inline-flex px-2 py-2 font-semibold text-center text-teal-900 bg-teal-400 border-0 rounded cursor-pointer lg:text-lg lg:px-6 focus:outline-none hover:bg-teal-500"
              aria-label="opensea"
            >View on Opensea</a>
          :''
        }
        </div>
      </section>
      <section
        id="about"
        className="lg:flex justify-between items-center m-auto xl:px-15% px-10 md:px-10% bg-white pt-12 pb-2"
      >
        <div className="flex flex-col items-start justify-center w-full content-area">
          <div className="w-5/6">
            <h1 className="text-4xl font-bold leading-10 text-teal-500 md:text-5xl">
              10,000 Babybad the Alpha Gang{" "}<span className="text-black">to be adopted from an orphanage.</span>
            </h1>
          </div>
          <p className="w-full text-xl text-gray-400 mt-11 lg:w-3/4">
            Babybad is a collection of generative artwork with original hand-drawn elements, spawning gangs of bad babies. Each unique gang will be dropped from all over the world gradually in 4 phases.
          </p>
        </div>
        <div className="md:mt-0 mt-14">
          <img src="assets/images/babybad/babybadlogo.png" className="hidden md:block w-96"/>
        </div>
      </section>
      <section id="carousel" className="p-3 bg-white">
        <img
          src="assets/images/babybad/previews.jpg"
          alt="-"
          className="w-full shadow-sm"
        />
      </section>
    </main>
  );
}

export default Body;
